import { render } from "./CampoCep.vue?vue&type=template&id=776f4cfc&ts=true"
import script from "./CampoCep.vue?vue&type=script&lang=ts"
export * from "./CampoCep.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__